interface LogoProps {
  dark?: boolean;
}

const LOGO_ICON = 'https://public.readdy.ai/ai/img_res/3160d0dc-ff55-408e-94e0-fb4f3deaa0bf.png';

export default function Logo({ dark = false }: LogoProps) {
  return (
    <a href="#top" className="flex items-center gap-3 cursor-pointer" aria-label="Let Me Clean home">
      <img
        src={LOGO_ICON}
        alt="Let Me Clean logo"
        width={44}
        height={44}
        className="w-11 h-11 shrink-0 object-contain"
      />
      <span className="flex flex-col leading-none">
        <span className={`font-heading font-bold text-xl md:text-2xl tracking-tight ${dark ? 'text-background-50' : 'text-foreground-950'}`}>
          let me <span className={dark ? 'text-accent-400' : 'text-accent-600'}>clean</span>
        </span>
        <span
          className={`mt-1 text-[11px] font-semibold tracking-[2px] ${dark ? 'text-secondary-200' : 'text-foreground-500'}`}
          style={{ fontFamily: 'var(--font-body)' }}
        >
          CHICAGO CLEANING
        </span>
      </span>
    </a>
  );
}